//@flow
import React from 'react';
import FloatLabelInput from '../../Form/components/FloatLabelInput.react';

export default function LoginFormName(props:{ formData?:Object }) {
  return (
    <div className="row">
      <span>
        <FloatLabelInput
          type="text"
          name="firstname"
          formData={props.formData}
          className="input-firstname"
          required={true}
          showFloat={true}
          placeholder="First name"
          title="First name"
        />
      </span>
      <span>
        <FloatLabelInput
          type="text"
          name="lastname"
          formData={props.formData}
          className="input-lastname"
          required={true}
          showFloat={true}
          placeholder="Last name"
          title="Last name"
        />
      </span>
    </div>
  );
}
